<h1 mat-dialog-title class="p-2 text-center">Historique des calibrages </h1>
<div *ngIf="Model" class="p-3">
    <div class="col">
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Date </mat-label>
                <input matInput placeholder="Date " [matDatepicker]="picker" [(ngModel)]="SearchDate" (focus)="picker.open()" >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="primary" (throttledClick)="getSondeDetails()">
                Rechercher
            </button>
        </div>

        <div *ngIf="Model.Type === EMasterSondeType.Oxygene" class="row">
            <table mat-table [dataSource]="Model.AjustageContexteList" class="mat-elevation-z8 w-100">
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="col">Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.Date | date:'short'}} </td>
                </ng-container>

                <ng-container matColumnDef="operateur">
                    <th mat-header-cell *matHeaderCellDef class="col"> operateur </th>
                    <td mat-cell *matCellDef="let element"> {{element.SamplerPuid}} </td>
                </ng-container>

                <ng-container matColumnDef="saturation">
                    <th mat-header-cell *matHeaderCellDef class="col"> saturation </th>
                    <td mat-cell *matCellDef="let element"> {{element.AjustageOxygene.Saturation}} </td>
                </ng-container>

                <ng-container matColumnDef="pression">
                    <th mat-header-cell *matHeaderCellDef class="col"> pression </th>
                    <td mat-cell *matCellDef="let element"> {{element.AjustageOxygene.Pression}} </td>
                </ng-container>

                <ng-container matColumnDef="pente">
                    <th mat-header-cell *matHeaderCellDef class="col"> pente </th>
                    <td mat-cell *matCellDef="let element"> {{element.AjustageOxygene.Pente}} </td>
                </ng-container>

                <ng-container matColumnDef="conforme">
                    <th mat-header-cell *matHeaderCellDef class="col"> Acceptation <br>(Entre 80% et 120%) </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [(ngModel)]="element.AjustageOxygene.Conforme"></mat-checkbox> -->
                        <div class="col-auto">
                            <mat-icon style="color: darkgreen;" *ngIf="element.AjustageOxygene.Conforme">task_alt</mat-icon>
                            <mat-icon style="color: red;" *ngIf="!element.AjustageOxygene.Conforme">task_alt</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="OxygeneColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: OxygeneColumns;"></tr>
            </table>
        </div>

        <div *ngIf="Model.Type === EMasterSondeType.Conductivite && Model.AjustageContexteList.length > 0" class="row">
            <div class="row justify-content-center">
                <div *ngFor="let a of Model.AjustageContexteList; let i = index " class="col-auto"> 
                    <mat-icon [style.color]="i === SelectedAjustageNumber ? 'black': 'grey'" class="material-symbols-outlined" (click)="SetSelectedAjustage(i)">counter_{{i + 1}}</mat-icon>
                </div>
            </div>
            <table mat-table [dataSource]="Model.AjustageContexteList[this.SelectedAjustageNumber]?.AjustageConductiviteList" class="mat-elevation-z8 w-100">
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Type</th>
                    <td mat-cell *matCellDef="let element"> {{getConductiviteLabel(element.ControleConductivite.Type)}} </td>
                </ng-container>

                <ng-container matColumnDef="numeroLot">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Numero Lot</th>
                    <td mat-cell *matCellDef="let element"> {{element.NumeroLot}} </td>
                </ng-container>

                <ng-container matColumnDef="dateOuverture">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Date Ouverture</th>
                    <td mat-cell *matCellDef="let element"> {{element.DateOuverture | date}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurMesuree">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Valeur Mesuree</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControleConductivite.ValeurMesuree}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurCible">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Valeur Cible</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControleConductivite.ValeurCible}} </td>
                </ng-container>

                <ng-container matColumnDef="temperature">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Temperature</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControleConductivite.Temperature}} </td>
                </ng-container>

                <ng-container matColumnDef="conforme">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">
                        <mat-icon class="material-symbols-outlined" matTooltip="conformité">
                            task_alt
                        </mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [(ngModel)]="element.ControleConductivite.Conforme" disabled></mat-checkbox> -->
                        <div class="col-auto">
                            <mat-icon style="color: darkgreen;" *ngIf="element.ControleConductivite.Conforme">task_alt</mat-icon>
                            <mat-icon style="color: red;" *ngIf="!element.ControleConductivite.Conforme">task_alt</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="ConductiviteAjustageColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: ConductiviteAjustageColumns;let even = even;" [ngClass]="{gray: even}"></tr>
            </table>

            <table mat-table [dataSource]="Model.AjustageContexteList[this.SelectedAjustageNumber]?.ControleConductiviteGroupeList" class="mat-elevation-z8 w-100">

                <!-- SUB HEADER  -->
                <ng-container matColumnDef="subHeaderSpacing">
                    <td mat-header-cell *matHeaderCellDef colspan="2" class="text-center">
                    </td>
                </ng-container>

                <ng-container matColumnDef="subHeader1413">
                    <td mat-header-cell *matHeaderCellDef colspan="4" class="text-center cell-background-blue">
                        Tampon 1413µS/cm
                    </td>
                </ng-container>

                <ng-container matColumnDef="subHeader84">
                    <td mat-header-cell *matHeaderCellDef colspan="4" class="text-center cell-background-saumon">
                        Tampon 84µS/cm
                    </td>
                </ng-container>
                <!-- !SUB HEADER  -->

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.Date | date:'shortDate'}} </td>
                </ng-container>

                <ng-container matColumnDef="operateur">
                    <th mat-header-cell *matHeaderCellDef class="col text-center"> opérateur </th>
                    <td mat-cell *matCellDef="let element"> {{element.SamplerPuid}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurMesureC1413">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-blue"> Valeur Mesurée </th>
                    <td mat-cell *matCellDef="let element"> {{element.C1413.ValeurMesuree}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurCibleC1413">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-blue"> Valeur Cible </th>
                    <td mat-cell *matCellDef="let element"> {{element.C1413.ValeurCible}} </td>
                </ng-container>

                <ng-container matColumnDef="temperatureC1413">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-blue"> Température </th>
                    <td mat-cell *matCellDef="let element"> {{element.C1413.Temperature}} </td>
                </ng-container>

                <ng-container matColumnDef="conformeC1413">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-blue">
                        <mat-icon class="material-symbols-outlined" matTooltip="conformité">
                            task_alt
                        </mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [(ngModel)]="element.C1413.Conforme" disabled></mat-checkbox> -->
                        <div class="col-auto">
                            <mat-icon style="color: darkgreen;" *ngIf="element.C1413.Conforme">task_alt</mat-icon>
                            <mat-icon style="color: red;" *ngIf="!element.C1413.Conforme">task_alt</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="valeurMesureC84">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Valeur Mesurée </th>
                    <td mat-cell *matCellDef="let element"> {{element.C84.ValeurMesuree}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurCibleC84">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Valeur Cible </th>
                    <td mat-cell *matCellDef="let element"> {{element.C84.ValeurCible}} </td>
                </ng-container>

                <ng-container matColumnDef="temperatureC84">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Température </th>
                    <td mat-cell *matCellDef="let element"> {{element.C84.Temperature}} </td>
                </ng-container>

                <ng-container matColumnDef="conformeC84">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">
                        <mat-icon class="material-symbols-outlined" matTooltip="conformité">
                            task_alt
                        </mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [(ngModel)]="element.C84.Conforme" disabled></mat-checkbox> -->
                        <div class="col-auto">
                            <mat-icon style="color: darkgreen;" *ngIf="element.C84.Conforme">task_alt</mat-icon>
                            <mat-icon style="color: red;" *ngIf="!element.C84.Conforme">task_alt</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['subHeaderSpacing', 'subHeader1413', 'subHeader84']" class="example-second-header-row">
                </tr>

                <tr mat-header-row *matHeaderRowDef="ConductiviteColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: ConductiviteColumns;"></tr>
            </table>
        </div>

        <div *ngIf="Model.Type === EMasterSondeType.PH && Model.AjustageContexteList.length > 0" class="row">
            <div class="row justify-content-center">
                <div *ngFor="let a of Model.AjustageContexteList; let i = index " class="col-auto"> 
                    <mat-icon [style.color]="i === SelectedAjustageNumber ? 'black': 'grey'" class="material-symbols-outlined" (click)="SetSelectedAjustage(i)">counter_{{i + 1}}</mat-icon>
                </div>
            </div>
            <table mat-table [dataSource]="Model.AjustageContexteList[this.SelectedAjustageNumber]?.AjustagePhList" class="mat-elevation-z8 w-100">
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Type</th>
                    <td mat-cell *matCellDef="let element"> {{getPhLabel(element.ControlePh.Type)}} </td>
                </ng-container>

                <ng-container matColumnDef="numeroLot">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Numero Lot</th>
                    <td mat-cell *matCellDef="let element"> {{element.NumeroLot}} </td>
                </ng-container>

                <ng-container matColumnDef="pente">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Pente</th>
                    <td mat-cell *matCellDef="let element"> {{element.Pente}} </td>
                </ng-container>

                <ng-container matColumnDef="decalage">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Decalage</th>
                    <td mat-cell *matCellDef="let element"> {{element.Decalage}} </td>
                </ng-container>

                <ng-container matColumnDef="controleNumeroLot">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Controle NumeroLot</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControlePh.ControleNumeroLot}} </td>
                </ng-container>

                <ng-container matColumnDef="temperature">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Temperature</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControlePh.Temperature}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurCible">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Valeur Cible</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControlePh.ValeurCible}} </td>
                </ng-container>

                <ng-container matColumnDef="valeurLue">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">Valeur Lue</th>
                    <td mat-cell *matCellDef="let element"> {{element.ControlePh.ValeurLue}} </td>
                </ng-container>

                <ng-container matColumnDef="conforme">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">
                        <mat-icon class="material-symbols-outlined" matTooltip="conformité">
                            task_alt
                        </mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [(ngModel)]="" disabled></mat-checkbox> -->
                        <div class="col-auto">
                            <mat-icon style="color: darkgreen;" *ngIf="element.ControlePh.Conforme">task_alt</mat-icon>
                            <mat-icon style="color: red;" *ngIf="!element.ControlePh.Conforme">task_alt</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="pHAjustageColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: pHAjustageColumns;let even = even;" [ngClass]="{gray: even}"></tr>
            </table>

            <table mat-table [dataSource]="Model.AjustageContexteList[this.SelectedAjustageNumber]?.ControlePhGroupeList" class="mat-elevation-z8 w-100">

                <!-- SUB HEADER  -->
                <!-- <ng-container matColumnDef="subHeaderSpacing">
                        <td mat-header-cell *matHeaderCellDef colspan="2" class="text-center">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="subHeader1413">
                        <td mat-header-cell *matHeaderCellDef colspan="4" class="text-center cell-background-blue">
                            Tampon 1413µS/cm
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="subHeader84">
                        <td mat-header-cell *matHeaderCellDef colspan="4" class="text-center cell-background-saumon">
                            Tampon 84µS/cm
                        </td>
                    </ng-container> -->
                <!-- !SUB HEADER  -->

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="col text-center">Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.Date | date:'shortDate'}} </td>
                </ng-container>

                <ng-container matColumnDef="operateur">
                    <th mat-header-cell *matHeaderCellDef class="col text-center"> opérateur </th>
                    <td mat-cell *matCellDef="let element"> {{element.SamplerPuid}} </td>
                </ng-container>

                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="col text-center "> Controle </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row justify-content-center">PH2</div>
                        <div class="row justify-content-center">PH7</div>
                        <div class="row justify-content-center">PH10</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="controleNumeroLot">
                    <th mat-header-cell *matHeaderCellDef class="col text-center "> Controle NumeroLot </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row justify-content-center">{{element.PH2.ControleNumeroLot}} </div>
                        <div class="row justify-content-center">{{element.PH7.ControleNumeroLot}} </div>
                        <div class="row justify-content-center">{{element.PH12.ControleNumeroLot}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="temp">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Temperature </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row justify-content-center">{{element.PH2.Temperature}} </div>
                        <div class="row justify-content-center">{{element.PH7.Temperature}} </div>
                        <div class="row justify-content-center">{{element.PH12.Temperature}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="valeurCible">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Valeur Cible </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row justify-content-center">{{element.PH2.ValeurCible}} </div>
                        <div class="row justify-content-center">{{element.PH7.ValeurCible}} </div>
                        <div class="row justify-content-center">{{element.PH12.ValeurCible}} </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="valeurLue">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon"> Valeur Lue </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row justify-content-center">{{element.PH2.ValeurLue}} </div>
                        <div class="row justify-content-center">{{element.PH7.ValeurLue}} </div>
                        <div class="row justify-content-center">{{element.PH12.ValeurLue}} </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="conforme">
                    <th mat-header-cell *matHeaderCellDef class="col text-center cell-background-saumon">
                        <mat-icon class="material-symbols-outlined" matTooltip="conformité">
                            task_alt
                        </mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="row">
                            <!-- <mat-checkbox class="mini-checkbox" [(ngModel)]="element.PH2.Conforme" disabled></mat-checkbox> -->
                            <div class="col-auto">
                                <mat-icon style="color: darkgreen;" *ngIf="element.PH2.Conforme">task_alt</mat-icon>
                                <mat-icon style="color: red;" *ngIf="!element.PH2.Conforme">task_alt</mat-icon>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <mat-checkbox class="mini-checkbox" [(ngModel)]="element.PH7.Conforme" disabled></mat-checkbox> -->
                            <div class="col-auto">
                                <mat-icon style="color: darkgreen;" *ngIf="element.PH7.Conforme">task_alt</mat-icon>
                                <mat-icon style="color: red;" *ngIf="!element.PH7.Conforme">task_alt</mat-icon>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <mat-checkbox class="mini-checkbox" [(ngModel)]="element.PH12.Conforme" disabled></mat-checkbox> -->
                            <div class="col-auto">
                                <mat-icon style="color: darkgreen;" *ngIf="element.PH12.Conforme">task_alt</mat-icon>
                                <mat-icon style="color: red;" *ngIf="!element.PH12.Conforme">task_alt</mat-icon>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- 
                    <tr mat-header-row *matHeaderRowDef="['subHeaderSpacing', 'subHeader1413', 'subHeader84']" class="example-second-header-row">
                    </tr> -->

                <tr mat-header-row *matHeaderRowDef="pHGroupControleColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: pHGroupControleColumns;let even = even;" [ngClass]="{gray: even}"></tr>
            </table>
        </div>

        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
        </div>

    </div>
</div>